import { ExternalTournament } from '@img-arena/consoles-api-streaming'
import { streamingRestApi } from '@/service/streamingApi'

import { createBaseTableStore } from '../table'
import { FetchApiResponse } from '../table/table.types'

export type UseImportEventsParamName = 'filter'

const fetchExternalTournamentsApi = async (): Promise<FetchApiResponse<ExternalTournament>> => {
  const data = await streamingRestApi.endpoints.importEvents.getExternalTournaments()

  const externalTournaments = Object.values(data).map((tournament) => tournament)

  return {
    content: externalTournaments,
    totalElements: externalTournaments.length
  }
}

export const useImportEventsStore = createBaseTableStore({
  storeName: 'Import Events',
  fetchApi: fetchExternalTournamentsApi
})
